export default function slacounttypes(state = [], action) {
    switch (action.type) {
        case 'ADD_CURRENT':
            return {
                ...state,
                slacounttype: action.slacounttype,
            }
        default:
            return state;
    }
}
